import React, { useEffect, useState } from "react";
import { selectTranslations } from "../../../config/i18n/slice";
import { useSelector } from "react-redux";
import { Divider, Image } from "semantic-ui-react";
import UserProfilePlaceholder from "../../../components/common/userProfilePlaceholder";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { ContactInfoIcon } from "../../../../Assets/Icons/svg";
import Moment from "react-moment";
import { humanize } from "../../../config/common/commonFunctions";

const VendorInfo = ({ targetedData }) => {
  const t = useSelector(selectTranslations);
  const history = useHistory();

  const selectedLanguage = useSelector((state) => {
    if (state?.i18n?.lang) {
      return state.i18n.lang;
    } else {
      return "en";
    }
  });

  const [fetching, setFetchLoading] = useState(true);
  const [data, setData] = useState(null);

  useEffect(() => {
    setFetchLoading(true);
    if (targetedData) {
      setData(targetedData);
      setFetchLoading(false);
    }
  }, [targetedData]);

  return (
    <div className="preview-details-wrapper">
      <>
        <div className="intro">
          <div className="flexbox align-center">
            <div>
              {targetedData?.attributes?.logo?.data?.attributes?.url ? (
                <div className="d-flex align-items-center">
                  <div className="customer-img text-center">
                    <Image
                      circular
                      title={targetedData.attributes?.name}
                      src={`${targetedData?.attributes?.logo.data.attributes.url}`}
                      // style={
                      //   selectedLanguage === "en"
                      //     ? { width: "80px", height: "80px", right: "6px" }
                      //     : { width: "80px", height: "80px", right: "-6px" }
                      // }
                    />
                  </div>
                  <div className="username-container ml-2">
                    <p className="people-text">
                      {targetedData?.attributes?.name
                        ? humanize(targetedData?.attributes?.name)
                        : ""}
                    </p>
                  </div>
                </div>
              ) : (
                <div className="d-flex align-items-center">
                  <div className="text-center">
                    <UserProfilePlaceholder
                      name={targetedData?.attributes?.name}
                      width={"80px"}
                      height={"80px"}
                      right={selectedLanguage === "en" ? "6px" : "-6px"}
                    />
                  </div>
                  <div className="username-container ml-1">
                    <p className="people-text">
                      {targetedData?.attributes?.name
                        ? humanize(targetedData?.attributes?.name)
                        : ""}
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="d-flex justify-content-end"></div>
        </div>

        <Divider />

        <div className="details-wrapper">
          <div className="d-flex align-items-start mt-6">
            <label className="workorder-intro-label vendor-label">
              {t.customers.form.description}
              {":"}
            </label>
            <p className="workorder-intro-value">
              {targetedData?.attributes?.description || t.common.na}
            </p>
          </div>

          <div className="d-flex align-items-start mt-5">
            <label className="workorder-intro-label vendor-label">
              {t.customers.form.email}
              {":"}
            </label>
            <p className="workorder-intro-value">
              {targetedData?.attributes?.email
                ? targetedData?.attributes?.email
                : t.common.na}
            </p>
          </div>

          <div className="d-flex align-items-start mt-5">
            <label className="workorder-intro-label vendor-label">
              {t.customers.form.phone}
              {":"}
            </label>
            <p className="workorder-intro-value">
              {targetedData?.attributes?.phone
                ? `${selectedLanguage == "en" ? "+" : ""}${
                    targetedData?.attributes?.phone
                  }${selectedLanguage == "ar" ? "+" : ""}`
                : t.common.na}
            </p>
          </div>

          <div className="d-flex align-items-start mt-5">
            <label className="workorder-intro-label vendor-label">
              {t.customers.form.location}
              {":"}
            </label>
            <p className="workorder-intro-value">
              {targetedData?.attributes?.location?.data?.id ? (
                <span
                  className="detail-intro-link"
                  onClick={() =>
                    history.push(
                      `/locations?id=${targetedData?.attributes?.location?.data?.attributes?.countId}`
                    )
                  }
                >
                  {targetedData?.attributes?.location?.data?.attributes?.name}
                </span>
              ) : (
                t.common.na
              )}
            </p>
          </div>

          <div className="d-flex align-items-start mt-5">
            <label className="workorder-intro-label vendor-label">
              {t.customers.form.website}
              {":"}
            </label>
            <p className="workorder-intro-value">
              {targetedData?.attributes?.website
                ? targetedData?.attributes?.website
                : t.common.na}
            </p>
          </div>

          <div className="d-flex align-items-start mt-5">
            <label className="workorder-intro-label vendor-label">
              {t.customers.form.service_type}
              {":"}
            </label>
            <p className="workorder-intro-value">
              {targetedData?.attributes?.serviceType
                ? targetedData?.attributes?.serviceType
                : t.common.na}
            </p>
          </div>

          <div className="d-flex align-items-center mt-5 mb-6">
            <label className="workorder-intro-label vendor-label">
              {t.common.industry}
              {":"}
            </label>
            <p className="workorder-intro-value">
              {targetedData?.attributes?.Industry
                ? targetedData?.attributes?.Industry
                : t.common.na}
            </p>
          </div>

          <div className="d-flex align-items-center mt-5 mb-6">
            <label className="workorder-intro-label vendor-label">
              {t.vendors.form.credit_days}
              {":"}
            </label>
            <p className="workorder-intro-value">
              {targetedData?.attributes?.creditDays
                ? targetedData?.attributes?.creditDays
                : t.common.na}
            </p>
          </div>

          <div className="d-flex align-items-center mt-5 mb-6">
            <label className="workorder-intro-label vendor-label">
              {t.vendors.form.start_date}
              {":"}
            </label>
            <p className="workorder-intro-value">
              {targetedData?.attributes?.startDate
                ? moment(targetedData?.attributes?.startDate).format(
                    "DD.MM.YYYY"
                  )
                : t.common.na}
            </p>
          </div>

          <div className="d-flex align-items-center mt-5 mb-6">
            <label className="workorder-intro-label vendor-label">
              {t.vendors.form.end_date}
              {":"}
            </label>
            <p className="workorder-intro-value">
              {targetedData?.attributes?.endDate
                ? moment(targetedData?.attributes?.endDate).format("DD.MM.YYYY")
                : t.common.na}
            </p>
          </div>

          <div className="d-flex align-items-center mt-5 mb-6">
            <label className="workorder-intro-label vendor-label">
              {t.customers.form.preferences}
              {":"}
            </label>
            <p className="workorder-intro-value">
              {targetedData?.attributes?.preferences
                ? targetedData?.attributes?.preferences
                : "English"}
            </p>
          </div>

          <Divider className="mt-7" />

          <div className="billing-info  d-flex mt-7">
            <ContactInfoIcon />
            <p
              className={`font16 required-text mt-1 ${
                selectedLanguage == "en" ? "ml-2" : "mr-2"
              }`}
            >
              {t.customers.form.contact_information}
            </p>
          </div>

          <div className="d-flex align-items-center mt-8">
            <label className="workorder-intro-label vendor-label">
              {t.customers.contact_name}
              {":"}
            </label>
            <p className="workorder-intro-value">
              {targetedData?.attributes?.contactInformation?.name
                ? targetedData?.attributes?.contactInformation?.name
                : t.common.na}
             
            </p>
          </div>

          <div className="d-flex align-items-center mt-5">
            <label className="workorder-intro-label vendor-label">
              {t.customers.contact_phone}
              {":"}
            </label>
            <p className="workorder-intro-value">
              {targetedData?.attributes?.contactInformation?.phone
                ? `${selectedLanguage == "en" ? "+" : ""}${
                    targetedData?.attributes?.contactInformation?.phone
                  }${selectedLanguage == "ar" ? "+" : ""}`
                : t.common.na}
            </p>
          </div>

          <div className="d-flex align-items-center mt-5">
            <label className="workorder-intro-label vendor-label">
              {t.customers.contact_email}
              {":"}
            </label>
            <p className="workorder-intro-value">
              {targetedData?.attributes?.contactInformation?.email
                ? targetedData?.attributes?.contactInformation?.email
                : t.common.na}
            </p>
          </div>

          <Divider />

          <div className="d-flex align-items-center mt-5">
            <label className="workorder-intro-label vendor-label grey">
              {t.workOrders.table.createdByUser}
              {":"}
            </label>
            <p className="workorder-intro-value grey">
              {targetedData?.attributes?.createdByUser?.data?.attributes
                ?.firstName &&
              targetedData?.attributes?.createdByUser?.data?.attributes
                ?.lastName
                ? targetedData?.attributes?.createdByUser?.data?.attributes
                    ?.firstName +
                  " " +
                  targetedData?.attributes?.createdByUser?.data?.attributes
                    ?.lastName
                : t.common.na}
              {", "}
              <Moment
                format="DD/MM/YYYY LT"
                date={targetedData?.attributes?.createdAt}
              />
            </p>
          </div>

          <div className="d-flex align-items-center mt-3">
            <label className="workorder-intro-label vendor-label grey">
              {t.common.update_by}
              {":"}
            </label>
            <p className="workorder-intro-value grey">
              {targetedData?.attributes?.updatedByUser?.data
                ? targetedData?.attributes?.updatedByUser?.data?.attributes
                    ?.firstName +
                  " " +
                  targetedData?.attributes?.updatedByUser?.data?.attributes
                    ?.lastName +
                  ", " +
                  moment(targetedData?.attributes?.updatedAt).format(
                    "DD/MM/YYYY LT"
                  )
                : t.common.na}
            </p>
          </div>
        </div>
      </>
    </div>
  );
};

export default VendorInfo;
